import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import './scss/Footer.scss';
import { menuLinks } from '../../constants';
import WithDeviceType from '../HOCs/WithDeviceType';
import ym from 'react-yandex-metrika';
import ReactGA from 'react-ga';
import MainModal from '../PromotionBlocks/MainModal';

const Footer = ({ desktop }) => {
  const { pathname } = useLocation();
  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
    ym('reachGoal', 'obsudit-proekt');
    ReactGA.event({
      category: 'appayer_sur_le_bouton',
      action: 'distuter_du_projet',
      label: 'distuter_du_projet_premier_bloc'
    });
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div className="footer">
      <div className='footer-brand' style={{display: 'flex', alignItems: 'center'}}>
      <NavLink to="/" className="footer__logo-title">
        <div className="footer__logo-logo">
          <svg className="footer__logo-pic" width="800" height="170" viewBox="0 0 800 170" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M796.022 28.6809C794.033 22.714 790.055 18.0731 785.414 14.0952C780.11 10.1173 774.143 6.80231 768.176 4.81335C760.22 2.82439 752.265 2.1614 744.309 2.1614H611.711V131.444L526.186 2.1614H497.678L412.152 131.444C412.152 129.455 412.815 127.466 412.815 124.814V105.587C412.815 99.6204 412.152 93.6536 410.163 88.3497C408.174 82.3828 404.197 77.7419 399.556 73.764C394.252 69.7861 388.285 66.4711 382.318 64.4822C374.362 62.4932 366.406 61.8302 358.45 61.8302H269.61C257.013 61.8302 257.013 56.5263 257.013 53.8744V44.5926C257.013 41.9406 257.013 36.6367 269.61 36.6367H406.185V0.172466H269.61C261.654 -0.490521 253.035 0.835412 245.743 2.82437C239.113 4.15035 233.146 7.46529 228.505 12.1062C223.864 16.0841 219.886 20.7251 217.897 26.6919C215.908 31.9958 215.245 37.9627 215.245 43.9296V53.2114C215.245 59.1783 215.908 65.1451 217.897 70.449C219.886 76.4159 223.864 81.0568 228.505 85.0347C233.809 89.0126 239.776 92.3276 245.743 94.3166C253.698 96.3055 261.654 96.9685 269.61 96.9685H359.776C372.373 96.9685 372.373 102.272 372.373 104.924V124.151C372.373 126.803 372.373 132.107 359.776 132.107H227.179L140.991 1.49842H112.482L0.437561 169.897H48.8356L124.416 51.8854L199.997 169.897H436.02L512.926 51.8854L588.507 169.897H655.469V112.88H745.635C753.59 113.543 762.209 112.217 769.502 110.228C776.132 108.902 782.099 105.587 786.74 100.946C791.381 96.9685 795.359 92.3276 797.348 86.3607C799.337 81.0568 800 75.0899 800 69.123V46.5815C800 40.6147 798.011 34.6477 796.022 28.6809ZM756.905 45.2555V68.4601C756.905 71.112 756.905 76.4159 744.309 76.4159H654.142V38.6257H744.309C756.905 38.6257 756.905 42.6036 756.905 45.2555Z" fill="white"/>
          </svg>
        </div>
      </NavLink>
        <p className="footer__copyright">
          &copy; {`2015–${new Date(Date.now()).getFullYear()} ASAP`}
        </p>
      </div>
      <div className="footer__nav">
        {menuLinks.map((link, i) =>
          pathname === '/promotion' || pathname === '/promotionlanding' ? (
            i < menuLinks.length - 1 ? (
              <HashLink smooth to={link.hash} className="menu-link" key={`hashLink--${i}`}>
                {/* {link.title === 'Услуги' ? 'Тарифы' : link.title} */}
                {link.title}
              </HashLink>
            ) : (
              <button
                type="button"
                className="menu-link"
                onClick={openModal}
                key={`hashLink--${i}`}
              >
                Начать проект
              </button>
            )
          ) : (
            <NavLink
              onClick={link.onClick}
              to={`/${link.link}`}
              className="menu-link"
              key={link.title}
            >
              {link.title}
            </NavLink>
          )
        )}
      </div>
      <a
        href="https://arda.digital/"
        target="_blank"
        className="footer__logo-title"
        rel="noreferrer"
        style={{width: '60px'}}
      >
        <div className="footer__logo-logo">
          <img
            src={require('../../assets/images/ARDA.png')}
            alt="ASAP"
            className="footer__logo-pic"
          />
        </div>
      </a>
      <MainModal modalIsOpen={modalIsOpen} closeModal={closeModal} desktop={desktop} />
    </div>
  );
};

export default WithDeviceType(Footer);
